import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

// components
import PrivateRoute from './PrivateRoute';

// lazy load all the views

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));

// dashboard
const Dashboard1 = React.lazy(() => import('../pages/dashboard/Dashboard1/'));
const Dashboard2 = React.lazy(() => import('../pages/dashboard/Dashboard2/'));
const Dashboard3 = React.lazy(() => import('../pages/dashboard/Dashboard3/'));
const Dashboard4 = React.lazy(() => import('../pages/dashboard/Dashboard4/'));

// apps
const CalendarApp = React.lazy(() => import('../pages/apps/Calendar/'));
const Projects = React.lazy(() => import('../pages/apps/Projects/'));
const ProjectDetail = React.lazy(() => import('../pages/apps/Projects/Detail/'));
const ProjectForm = React.lazy(() => import('../pages/apps/Projects/ProjectForm'));

// - chat
const ChatApp = React.lazy(() => import('../pages/crm/Chat/Home/Chat'));

// - statistics
const Statistics = React.lazy(() => import('../pages/crm/Statistics'));

// - file manager
const FilesManager = React.lazy(() => import('../pages/crm/FileManager'));

// - ecommece pages
const EcommerceDashboard = React.lazy(() => import('../pages/apps/Ecommerce/Dashboard/'));
const EcommerceProducts = React.lazy(() => import('../pages/apps/Ecommerce/Products'));
const ProductDetails = React.lazy(() => import('../pages/apps/Ecommerce/ProductDetails'));
const ProductEdit = React.lazy(() => import('../pages/apps/Ecommerce/ProductEdit'));
const Customers = React.lazy(() => import('../pages/apps/Ecommerce/Customers'));
const Orders = React.lazy(() => import('../pages/apps/Ecommerce/Orders'));
const OrderDetails = React.lazy(() => import('../pages/apps/Ecommerce/OrderDetails'));
const Sellers = React.lazy(() => import('../pages/apps/Ecommerce/Sellers'));
const Cart = React.lazy(() => import('../pages/apps/Ecommerce/Cart'));
const Checkout = React.lazy(() => import('../pages/apps/Ecommerce/Checkout'));
// - crm pages
const CRMDashboard = React.lazy(() => import('../pages/apps/CRM/Dashboard/'));
const CRMContacts = React.lazy(() => import('../pages/apps/CRM/Contacts/'));
const Opportunities = React.lazy(() => import('../pages/apps/CRM/Opportunities/'));
const CRMLeads = React.lazy(() => import('../pages/apps/CRM/Leads/'));
const CRMCustomers = React.lazy(() => import('../pages/apps/CRM/Customers/'));
// - email
const Inbox = React.lazy(() => import('../pages/apps/Email/Inbox'));
const EmailDetail = React.lazy(() => import('../pages/apps/Email/Detail'));
const EmailCompose = React.lazy(() => import('../pages/apps/Email/Compose'));
// - social
const SocialFeed = React.lazy(() => import('../pages/apps/SocialFeed/'));
// - companies
const Companies = React.lazy(() => import('../pages/apps/Companies/'));
// - tasks
//const TaskList = React.lazy(() => import('../pages/apps/Tasks/List/'));
const TaskDetails = React.lazy(() => import('../pages/apps/Tasks/Details'));
//const Kanban = React.lazy(() => import('../pages/apps/Tasks/Board/'));
// -contacts
const ContactsList = React.lazy(() => import('../pages/apps/Contacts/List/'));
const ContactsProfile = React.lazy(() => import('../pages/apps/Contacts/Profile/'));
// -tickets
const TicketsList = React.lazy(() => import('../pages/apps/Tickets/List/'));
const TicketsDetails = React.lazy(() => import('../pages/apps/Tickets/Details/'));
// - file
const FileManager = React.lazy(() => import('../pages/apps/FileManager'));

// extra pages
const Timeline = React.lazy(() => import('../pages/other/Timeline'));
const Sitemap = React.lazy(() => import('../pages/other/Sitemap/'));
// - other
const Invoice = React.lazy(() => import('../pages/other/Invoice'));
const FAQ = React.lazy(() => import('../pages/other/FAQ'));
const SearchResults = React.lazy(() => import('../pages/other/SearchResults/'));
const Pricing = React.lazy(() => import('../pages/other/Pricing'));
const Gallery = React.lazy(() => import('../pages/other/Gallery/'));

// uikit
const Buttons = React.lazy(() => import('../pages/uikit/Buttons'));
const Avatars = React.lazy(() => import('../pages/uikit/Avatars'));
const Cards = React.lazy(() => import('../pages/uikit/Cards'));
const Portlets = React.lazy(() => import('../pages/uikit/Portlets'));
const TabsAccordions = React.lazy(() => import('../pages/uikit/TabsAccordions'));
const Progress = React.lazy(() => import('../pages/uikit/Progress'));
const Modals = React.lazy(() => import('../pages/uikit/Modals'));
const Notifications = React.lazy(() => import('../pages/uikit/Notifications'));
const Offcanvases = React.lazy(() => import('../pages/uikit/Offcanvas'));
const Placeholders = React.lazy(() => import('../pages/uikit/Placeholders'));
const Spinners = React.lazy(() => import('../pages/uikit/Spinners'));
const Images = React.lazy(() => import('../pages/uikit/Images'));
const Carousels = React.lazy(() => import('../pages/uikit/Carousel'));
const ListGroups = React.lazy(() => import('../pages/uikit/ListGroups'));
const EmbedVideo = React.lazy(() => import('../pages/uikit/EmbedVideo'));
const Dropdowns = React.lazy(() => import('../pages/uikit/Dropdowns'));
const Ribbons = React.lazy(() => import('../pages/uikit/Ribbons'));
const TooltipsPopovers = React.lazy(() => import('../pages/uikit/TooltipsPopovers'));
const GeneralUI = React.lazy(() => import('../pages/uikit/GeneralUI'));
const Typography = React.lazy(() => import('../pages/uikit/Typography'));
const Grid = React.lazy(() => import('../pages/uikit/Grid'));
const NestableList = React.lazy(() => import('../pages/uikit/NestableList'));
const DragDrop = React.lazy(() => import('../pages/uikit/DragDrop'));
const RangeSliders = React.lazy(() => import('../pages/uikit/RangeSliders'));
const Animation = React.lazy(() => import('../pages/uikit/Animation'));
const TourPage = React.lazy(() => import('../pages/uikit/TourPage'));
const SweetAlerts = React.lazy(() => import('../pages/uikit/SweetAlerts'));
const LoadingButtons = React.lazy(() => import('../pages/uikit/LoadingButtons'));

// widgets
const Widgets = React.lazy(() => import('../pages/uikit/Widgets'));

// icons
const TwoToneIcons = React.lazy(() => import('../pages/icons/TwoToneIcons/'));
const FeatherIcons = React.lazy(() => import('../pages/icons/FeatherIcons/'));
const Dripicons = React.lazy(() => import('../pages/icons/Dripicons/'));
const MDIIcons = React.lazy(() => import('../pages/icons/MDIIcons/'));
const FontAwesomeIcons = React.lazy(() => import('../pages/icons/FontAwesomeIcons/'));
const ThemifyIcons = React.lazy(() => import('../pages/icons/ThemifyIcons/'));
const SimpleLineIcons = React.lazy(() => import('../pages/icons/SimpleLineIcons/'));
const WeatherIcons = React.lazy(() => import('../pages/icons/WeatherIcons/'));

// forms
const BasicForms = React.lazy(() => import('../pages/forms/Basic'));
const FormAdvanced = React.lazy(() => import('../pages/forms/Advanced'));
const FormValidation = React.lazy(() => import('../pages/forms/Validation'));
const FormWizard = React.lazy(() => import('../pages/forms/Wizard'));
const FileUpload = React.lazy(() => import('../pages/forms/FileUpload'));
const Editors = React.lazy(() => import('../pages/forms/Editors'));

// tables
const BasicTables = React.lazy(() => import('../pages/tables/Basic'));
const AdvancedTables = React.lazy(() => import('../pages/tables/Advanced'));

// charts
const ApexChart = React.lazy(() => import('../pages/charts/Apex'));
const ChartJs = React.lazy(() => import('../pages/charts/ChartJs'));

// avora crm

// home
// const Home = React.lazy(() => import('../pages/crm/Home/'));

// tasks
const TaskList = React.lazy(() => import('../pages/crm/Tasks/List/'));
const TaskView = React.lazy(() => import('../pages/crm/Tasks/Details/'));

// meetings
const MeetingList = React.lazy(() => import('../pages/crm/Meetings/List/'));

// calendar
const CalendarView = React.lazy(() => import('../pages/crm/Calendar/'));

// phonebook
const Phonebook = React.lazy(() => import('../pages/crm/Phonebook/'));

// companies
const CompaniesList = React.lazy(() => import('../pages/crm/Companies/List/'));
const CompaniesEdit = React.lazy(() => import('../pages/crm/Companies/Edit/'));
const CompaniesInfo = React.lazy(() => import('../pages/crm/Companies/Info/'));

// notes
const NoteList = React.lazy(() => import('../pages/crm/Notes/'));

// call logs
const CalllogList = React.lazy(() => import('../pages/crm/Calllogs/'));

// support
const TicketList = React.lazy(() => import('../pages/crm/Support/List/TicketList'));
const TicketInfo = React.lazy(() => import('../pages/crm/Support/'));

// sales
const SalesList = React.lazy(() => import('../pages/crm/Sales/List/SalesList'));
const SalesInfo = React.lazy(() => import('../pages/crm/Sales/'));

// employees
const EmployeesList = React.lazy(() => import('../pages/crm/Employees/List/'));
const EmployeesEdit = React.lazy(() => import('../pages/crm/Employees/Edit/'));
const EmployeesInfo = React.lazy(() => import('../pages/crm/Employees/Info/'));

// chat
const ChatHome = React.lazy(() => import('../pages/crm/Chat/Home/'));

// workspaces
const WorkspaceList = React.lazy(() => import('../pages/crm/Kanban/Workspaces/List/'));
const Kanban = React.lazy(() => import('../pages/crm/Kanban/Board/'));

// settings
const AuditLog = React.lazy(() => import('../pages/settings/AuditLog/'));
const WorkLog = React.lazy(() => import('../pages/settings/WorkLog/'));
const FormBuilderAdmin = React.lazy(() => import('../pages/settings/FormBuilderAdmin/'));
const Templates = React.lazy(() => import('../pages/settings/Templates/'));
const PersistedSettingsAdmin = React.lazy(() => import('../pages/settings/PersistedSettingsAdmin/'));
const PermissionManager = React.lazy(() => import('../pages/settings/PermissionManager/'));

// sysadmin
const ClearAPICache = React.lazy(() => import('../pages/sysadmin/ClearAPICache/'));
const UserLimit = React.lazy(() => import('../pages/sysadmin/UserLimit/'));
const SMTPSettings = React.lazy(() => import('../pages/sysadmin/SMTPSettings/'));

// dev
const PageBuilderDemo = React.lazy(() => import('../pages/dev/PageBuilderDemo'));
const FormBuilderDemo = React.lazy(() => import('../pages/dev/FormBuilderDemo'));
const FormBuilderLeo = React.lazy(() => import('../pages/dev/FormBuilderLeo'));

// misc internal

// misc external
const Maintenance = React.lazy(() => import('../pages/misc/Maintenance'));

export interface RoutesProps {
    path: RouteProps['path'];
    name?: string;
    component?: RouteProps['component'];
    route?: any;
    exact?: RouteProps['exact'];
    icon?: string;
    header?: string;
    roles?: string[];
    children?: RoutesProps[];
}

// root routes
const rootRoute: RoutesProps = {
    path: '/',
    exact: true,
    // component: Home,
    component: WorkspaceList,
    route: Route,
};

const devRoutes: RoutesProps = {
    path: '/dev',
    name: 'DEV',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/dev/pagebuilder',
            name: 'PageBuilder',
            exact: true,
            component: PageBuilderDemo,
            route: PrivateRoute,
        },
        {
            path: '/dev/formbuilder',
            name: 'FormBuilder',
            exact: true,
            component: FormBuilderDemo,
            route: PrivateRoute,
        },
        {
            path: '/dev/formbuilderleo',
            name: 'FormBuilderLeo',
            exact: true,
            component: FormBuilderLeo,
            route: PrivateRoute,
        },
        {
            path: '/dev/formbuilder/:truecolor',
            name: 'FormBuilder',
            exact: true,
            component: FormBuilderDemo,
            route: PrivateRoute,
        },
    ],
};

const onePageRoutes: RoutesProps = {
    path: '/crm',
    name: 'CRM',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/calendar',
            name: 'Calendar',
            exact: true,
            component: CalendarView,
            route: PrivateRoute,
        },
        {
            path: '/crm/phonebook',
            name: 'Phonebook',
            exact: true,
            component: Phonebook,
            route: PrivateRoute,
        },
        {
            path: '/crm/phonebook/:id',
            name: 'Phonebook',
            exact: true,
            component: Phonebook,
            route: PrivateRoute,
        },
    ],
};

const crmRoutes: RoutesProps = {
    path: '/crm/todos',
    name: 'CRM',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/todos',
            name: 'Todos',
            exact: true,
            component: TaskList,
            route: PrivateRoute,
        },
        {
            path: '/crm/todos/:id',
            name: 'TodoView',
            exact: true,
            component: TaskView,
            route: PrivateRoute,
        },
    ],
};

const kanbanRoutes: RoutesProps = {
    path: '/crm/boards',
    name: 'Kanban',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/boards',
            name: 'Boards',
            exact: true,
            component: WorkspaceList,
            route: PrivateRoute,
        },
        {
            path: '/crm/boards/:id',
            name: 'TodoView',
            exact: true,
            component: Kanban,
            route: PrivateRoute,
        },
    ],
};

const meetingRoutes: RoutesProps = {
    path: '/crm/meetings',
    name: 'Meeting',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/meetings',
            name: 'Meetings',
            exact: true,
            component: MeetingList,
            route: PrivateRoute,
        },
    ],
};

const companiesRoutes: RoutesProps = {
    path: '/crm/companies',
    name: 'Companies',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/companies',
            name: 'Company list',
            exact: true,
            component: CompaniesList,
            route: PrivateRoute,
        },
        {
            path: '/crm/companies/new',
            name: 'Company new',
            exact: true,
            component: CompaniesEdit,
            route: PrivateRoute,
        },
        {
            path: '/crm/companies/:id/edit',
            name: 'Company edit',
            exact: true,
            component: CompaniesEdit,
            route: PrivateRoute,
        },
        {
            path: '/crm/companies/:id/info',
            name: 'Company info',
            exact: true,
            component: CompaniesInfo,
            route: PrivateRoute,
        },
    ],
};

const notesRoutes: RoutesProps = {
    path: '/crm/notes',
    name: 'Notes',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/notes',
            name: 'List of notes',
            exact: true,
            component: NoteList,
            route: PrivateRoute,
        },
    ],
};

const calllogRoutes: RoutesProps = {
    path: '/crm/calllogs',
    name: 'Call Logs',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/calllogs',
            name: 'List of call logs',
            exact: true,
            component: CalllogList,
            route: PrivateRoute,
        },
    ],
};

const supportRoutes: RoutesProps = {
    path: '/crm/support',
    name: 'Support',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/support',
            name: 'Ticket list',
            exact: true,
            component: TicketList,
            route: PrivateRoute,
        },
        {
            path: '/crm/support/:id/info',
            name: 'Ticket info',
            exact: true,
            component: TicketInfo,
            route: PrivateRoute,
        },
    ],
};

const salesRoutes: RoutesProps = {
    path: '/crm/sales',
    name: 'Sales',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/sales',
            name: 'Sales list',
            exact: true,
            component: SalesList,
            route: PrivateRoute,
        },
        {
            path: '/crm/sales/:id/info',
            name: 'Sales info',
            exact: true,
            component: SalesInfo,
            route: PrivateRoute,
        },
    ],
};

const employeesRoutes: RoutesProps = {
    path: '/crm/employees',
    name: 'Employees',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/employees',
            name: 'Employee list',
            exact: true,
            component: EmployeesList,
            route: PrivateRoute,
        },
        {
            path: '/crm/employees/new',
            name: 'Employee add',
            exact: true,
            component: EmployeesEdit,
            route: PrivateRoute,
        },
        {
            path: '/crm/employees/:id/edit',
            name: 'Employee edit',
            exact: true,
            component: EmployeesEdit,
            route: PrivateRoute,
        },
        {
            path: '/crm/employees/:id/info',
            name: 'Employee info',
            exact: true,
            component: EmployeesInfo,
            route: PrivateRoute,
        },
        {
            path: '/crm/employees/:id/log',
            name: 'Employee log',
            exact: true,
            component: AuditLog,
            route: PrivateRoute,
        },
    ],
};

const crmEmployeeChatRoutes: RoutesProps = {
    path: '/crm/chat',
    name: 'Employeechat',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/chat',
            name: 'Chat home',
            exact: true,
            component: ChatHome,
            route: PrivateRoute,
        },
        {
            path: '/crm/chat/:chatId',
            name: 'Chat conversation',
            exact: true,
            component: ChatHome,
            route: PrivateRoute,
        },
    ],
};

const crmStatisticsRoutes: RoutesProps = {
    path: '/crm/stats',
    name: 'Statistics',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/stats',
            name: 'Statistics',
            exact: true,
            component: Statistics,
            route: PrivateRoute,
        },
    ],
};

const crmFileManagerRoutes: RoutesProps = {
    path: '/crm/files',
    name: 'Filemanager',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/crm/files',
            name: 'File manager',
            exact: true,
            component: FilesManager,
            route: PrivateRoute,
        },
    ],
};

const sysadminRoutes: RoutesProps = {
    path: '/sysadmin',
    name: 'Sysadmin',
    icon: 'settings',
    header: 'Navigation',
    children: [
        {
            path: '/sysadmin/cache',
            exact: true,
            name: 'ClearCache',
            component: ClearAPICache,
            route: PrivateRoute,
        },
        {
            path: '/sysadmin/userlimit',
            exact: true,
            name: 'UserLimit',
            component: UserLimit,
            route: PrivateRoute,
        },
        {
            path: '/sysadmin/smtp',
            exact: true,
            name: 'SMTPSettings',
            component: SMTPSettings,
            route: PrivateRoute,
        },
    ],
};

const settingsRoutes: RoutesProps = {
    path: '/settings',
    name: 'Settings',
    icon: 'settings',
    header: 'Navigation',
    children: [
        {
            path: '/settings/auditlog',
            exact: true,
            name: 'Audit log',
            component: AuditLog,
            route: PrivateRoute,
        },
        {
            path: '/settings/worklog',
            exact: true,
            name: 'Work log',
            component: WorkLog,
            route: PrivateRoute,
        },
        {
            path: '/settings/fields',
            exact: true,
            name: 'Custom fields',
            component: FormBuilderAdmin,
            route: PrivateRoute,
        },
        {
            path: '/settings/templates',
            exact: true,
            name: 'Custom templates',
            component: Templates,
            route: PrivateRoute,
        },
        {
            path: '/settings/persistedsettings',
            exact: true,
            name: 'Persisted settings',
            component: PersistedSettingsAdmin,
            route: PrivateRoute,
        },
        {
            path: '/settings/rights',
            exact: true,
            name: 'Rights settings',
            component: PermissionManager,
            route: PrivateRoute,
        },
    ],
};

// dashboards
const dashboardRoutes: RoutesProps = {
    path: '/dashboard',
    name: 'Dashboards',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/dashboard-1',
            name: 'Dashboard 1',
            component: Dashboard1,
            route: PrivateRoute,
        },
        {
            path: '/dashboard-2',
            name: 'Dashboard 2',
            component: Dashboard2,
            route: PrivateRoute,
        },
        {
            path: '/dashboard-3',
            name: 'Dashboard 3',
            component: Dashboard3,
            route: PrivateRoute,
        },
        {
            path: '/dashboard-4',
            name: 'Dashboard 4',
            component: Dashboard4,
            route: PrivateRoute,
        },
    ],
};

const calendarAppRoutes: RoutesProps = {
    path: '/apps/calendar',
    name: 'Calendar',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'calendar',
    component: CalendarApp,
    header: 'Apps',
};

const chatAppRoutes = {
    path: '/apps/chat',
    name: 'Chat',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'message-square',
    component: ChatApp,
};

const ecommerceAppRoutes = {
    path: '/apps/ecommerce',
    name: 'eCommerce',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'shopping-cart',
    children: [
        {
            path: '/apps/ecommerce/dashboard',
            name: 'Products',
            component: EcommerceDashboard,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/products',
            name: 'Products',
            component: EcommerceProducts,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/product-details',
            name: 'Product Details',
            component: ProductDetails,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/edit-product',
            name: 'Product Edit',
            component: ProductEdit,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/customers',
            name: 'Customers',
            component: Customers,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/orders',
            name: 'Orders',
            component: Orders,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/order/details',
            name: 'Order Details',
            component: OrderDetails,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/sellers',
            name: 'Sellers',
            component: Sellers,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/shopping-cart',
            name: 'Shopping Cart',
            component: Cart,
            route: PrivateRoute,
        },
        {
            path: '/apps/ecommerce/checkout',
            name: 'Checkout',
            component: Checkout,
            route: PrivateRoute,
        },
    ],
};

const crmAppRoutes = {
    path: '/apps/crm',
    name: 'CRM',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'users',
    children: [
        {
            path: '/apps/crm/dashboard',
            name: 'Dashboard',
            component: CRMDashboard,
            route: PrivateRoute,
        },
        {
            path: '/apps/crm/contacts',
            name: 'Contacts',
            component: CRMContacts,
            route: PrivateRoute,
        },
        {
            path: '/apps/crm/opportunities',
            name: 'Opportunities',
            component: Opportunities,
            route: PrivateRoute,
        },
        {
            path: '/apps/crm/leads',
            name: 'Leads',
            component: CRMLeads,
            route: PrivateRoute,
        },
        {
            path: '/apps/crm/customers',
            name: 'Customers',
            component: CRMCustomers,
            route: PrivateRoute,
        },
    ],
};

const emailAppRoutes = {
    path: '/apps/email',
    name: 'Email',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'mail',
    children: [
        {
            path: '/apps/email/inbox',
            name: 'Inbox',
            component: Inbox,
            route: PrivateRoute,
        },
        {
            path: '/apps/email/details',
            name: 'Email Details',
            component: EmailDetail,
            route: PrivateRoute,
        },
        {
            path: '/apps/email/compose',
            name: 'Compose Email',
            component: EmailCompose,
            route: PrivateRoute,
        },
    ],
};

const socialAppRoutes = {
    path: '/apps/social-feed',
    name: 'Social Feed',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'rss',
    component: SocialFeed,
};

const companiesAppRoutes = {
    path: '/apps/companies',
    name: 'Companies',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'activity',
    component: Companies,
};

const projectAppRoutes = {
    path: '/apps/projects',
    name: 'Projects',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'uil-briefcase',

    children: [
        {
            path: '/apps/projects/list',
            name: 'List',
            component: Projects,
            route: PrivateRoute,
        },
        {
            path: '/apps/projects/:id/details',
            name: 'Detail',
            component: ProjectDetail,
            route: PrivateRoute,
        },
        {
            path: '/apps/projects/create',
            name: 'Create Project',
            component: ProjectForm,
            route: PrivateRoute,
        },
    ],
};

const taskAppRoutes = {
    path: '/apps/tasks',
    name: 'Tasks',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'clipboard',
    children: [
        {
            path: '/apps/tasks/list',
            name: 'Task List',
            component: TaskList,
            route: PrivateRoute,
        },
        {
            path: '/apps/tasks/details',
            name: 'Task List',
            component: TaskDetails,
            route: PrivateRoute,
        },
        {
            path: '/apps/tasks/kanban',
            name: 'Kanban',
            component: Kanban,
            route: PrivateRoute,
        },
    ],
};

const contactsRoutes = {
    path: '/apps/contacts',
    name: 'Contacts',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'book',
    children: [
        {
            path: '/apps/contacts/list',
            name: 'Task List',
            component: ContactsList,
            route: PrivateRoute,
        },
        {
            path: '/apps/contacts/profile',
            name: 'Profile',
            component: ContactsProfile,
            route: PrivateRoute,
        },
    ],
};

const ticketsRoutes = {
    path: '/apps/tickets',
    name: 'Tickets',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'aperture',
    children: [
        {
            path: '/apps/tickets/list',
            name: 'List',
            component: TicketsList,
            route: PrivateRoute,
        },
        {
            path: '/apps/tickets/details',
            name: 'Details',
            component: TicketsDetails,
            route: PrivateRoute,
        },
    ],
};

const fileAppRoutes = {
    path: '/apps/file-manager',
    name: 'File Manager',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'folder-plus',
    component: FileManager,
};

const appRoutes = [
    calendarAppRoutes,
    chatAppRoutes,
    ecommerceAppRoutes,
    crmAppRoutes,
    emailAppRoutes,
    socialAppRoutes,
    companiesAppRoutes,
    projectAppRoutes,
    taskAppRoutes,
    contactsRoutes,
    ticketsRoutes,
    fileAppRoutes,
];

// pages
const extrapagesRoutes = {
    path: '/pages',
    name: 'Pages',
    icon: 'package',
    header: 'Custom',
    children: [
        {
            path: '/pages/timeline',
            name: 'Timeline',
            component: Timeline,
            route: PrivateRoute,
        },
        {
            path: '/pages/sitemap',
            name: 'Sitemap',
            component: Sitemap,
            route: PrivateRoute,
        },
        {
            path: '/pages/invoice',
            name: 'Invoice',
            component: Invoice,
            route: PrivateRoute,
        },
        {
            path: '/pages/faq',
            name: 'FAQ',
            component: FAQ,
            route: PrivateRoute,
        },
        {
            path: '/pages/serach-results',
            name: 'Search Results',
            component: SearchResults,
            route: PrivateRoute,
        },
        {
            path: '/pages/pricing',
            name: 'Pricing',
            component: Pricing,
            route: PrivateRoute,
        },
        {
            path: '/pages/gallery',
            name: 'Gallery',
            component: Gallery,
            route: PrivateRoute,
        },
    ],
};

// ui
const uiRoutes = {
    path: '/ui',
    name: 'Components',
    icon: 'pocket',
    header: 'UI Elements',
    children: [
        {
            path: '/ui/base',
            name: 'Base UI',
            children: [
                {
                    path: '/ui/buttons',
                    name: 'Buttons',
                    component: Buttons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/cards',
                    name: 'Cards',
                    component: Cards,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/avatars',
                    name: 'Avatars',
                    component: Avatars,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/portlets',
                    name: 'Portlets',
                    component: Portlets,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/tabs-accordions',
                    name: 'Tabs & Accordions',
                    component: TabsAccordions,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/progress',
                    name: 'Progress',
                    component: Progress,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/modals',
                    name: 'Modals',
                    component: Modals,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/notifications',
                    name: 'Notifications',
                    component: Notifications,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/offcanvas',
                    name: 'Offcanvas',
                    component: Offcanvases,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/placeholders',
                    name: 'Placeholders',
                    component: Placeholders,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/spinners',
                    name: 'Spinners',
                    component: Spinners,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/images',
                    name: 'Images',
                    component: Images,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/carousel',
                    name: 'Carousel',
                    component: Carousels,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/listgroups',
                    name: 'List Groups',
                    component: ListGroups,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/embedvideo',
                    name: 'EmbedVideo',
                    component: EmbedVideo,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/dropdowns',
                    name: 'Dropdowns',
                    component: Dropdowns,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/ribbons',
                    name: 'Ribbons',
                    component: Ribbons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/tooltips-popovers',
                    name: 'Tooltips & Popovers',
                    component: TooltipsPopovers,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/typography',
                    name: 'Typography',
                    component: Typography,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/grid',
                    name: 'Grid',
                    component: Grid,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/general',
                    name: 'General UI',
                    component: GeneralUI,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/ui/extended',
            name: 'Extended UI',
            children: [
                {
                    path: '/extended-ui/nestable',
                    name: 'Nestable List',
                    component: NestableList,
                    route: PrivateRoute,
                },
                {
                    path: '/extended-ui/dragdrop',
                    name: 'Drag and Drop',
                    component: DragDrop,
                    route: PrivateRoute,
                },
                {
                    path: '/extended-ui/rangesliders',
                    name: 'Range Sliders',
                    component: RangeSliders,
                    route: PrivateRoute,
                },
                {
                    path: '/extended-ui/animation',
                    name: 'Animation',
                    component: Animation,
                    route: PrivateRoute,
                },
                {
                    path: '/extended-ui/sweet-alert',
                    name: 'Sweet Alert',
                    component: SweetAlerts,
                    route: PrivateRoute,
                },
                {
                    path: '/extended-ui/tour',
                    name: 'Tour Page',
                    component: TourPage,
                    route: PrivateRoute,
                },
                {
                    path: '/extended-ui/loading-buttons',
                    name: 'Loading Buttons',
                    component: LoadingButtons,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/ui/widgets',
            name: 'Widgets',
            component: Widgets,
            route: PrivateRoute,
        },
        {
            path: '/ui/icons',
            name: 'Icons',
            children: [
                {
                    path: '/ui/icons/two-tone',
                    name: 'Two Tone Icons',
                    component: TwoToneIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/icons/feather',
                    name: 'Feather Icons',
                    component: FeatherIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/icons/dripicons',
                    name: 'Dripicons',
                    component: Dripicons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/icons/mdi',
                    name: 'Material Design',
                    component: MDIIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/icons/font-awesome',
                    name: 'Font Awesome 5',
                    component: FontAwesomeIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/icons/themify',
                    name: 'Themify',
                    component: ThemifyIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/icons/simple-line',
                    name: 'Simple Line Icons',
                    component: SimpleLineIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/icons/weather',
                    name: 'Weather Icons',
                    component: WeatherIcons,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/ui/forms',
            name: 'Forms',
            children: [
                {
                    path: '/ui/forms/basic',
                    name: 'Basic Elements',
                    component: BasicForms,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/forms/advanced',
                    name: 'Form Advanced',
                    component: FormAdvanced,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/forms/validation',
                    name: 'Form Validation',
                    component: FormValidation,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/forms/wizard',
                    name: 'Form Wizard',
                    component: FormWizard,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/forms/upload',
                    name: 'File Upload',
                    component: FileUpload,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/forms/editors',
                    name: 'Editors',
                    component: Editors,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/ui/tables',
            name: 'Tables',
            children: [
                {
                    path: '/ui/tables/basic',
                    name: 'Basic',
                    component: BasicTables,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/tables/advanced',
                    name: 'Advanced',
                    component: AdvancedTables,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/ui/charts',
            name: 'Charts',
            children: [
                {
                    path: '/ui/charts/apex',
                    name: 'Apex',
                    component: ApexChart,
                    route: PrivateRoute,
                },
                {
                    path: '/ui/charts/chartjs',
                    name: 'Chartjs',
                    component: ChartJs,
                    route: PrivateRoute,
                },
            ],
        },
    ],
};

const miscPrivateRoutes: RoutesProps[] = [
    {
        path: '/about',
        name: 'About',
        component: FAQ,
        route: PrivateRoute,
    },
];

// public routes
const authRoutes: RoutesProps[] = [
    {
        path: '/auth/login',
        name: 'Login',
        component: Login,
        route: Route,
    },
    {
        path: '/auth/logout',
        name: 'Logout',
        component: Logout,
        route: Route,
    },
];

const miscPublicRoutes: RoutesProps[] = [
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance,
        route: Route,
    },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
    let flatRoutes: RoutesProps[] = [];

    routes = routes || [];
    routes.forEach((item: RoutesProps) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const authProtectedRoutes = [
    rootRoute,
    devRoutes,
    onePageRoutes,
    crmRoutes,
    meetingRoutes,
    companiesRoutes,
    notesRoutes,
    calllogRoutes,
    supportRoutes,
    salesRoutes,
    employeesRoutes,
    crmEmployeeChatRoutes,
    crmStatisticsRoutes,
    crmFileManagerRoutes,
    settingsRoutes,
    sysadminRoutes,
    kanbanRoutes,
    dashboardRoutes,
    ...appRoutes,
    extrapagesRoutes,
    uiRoutes,
    ...miscPrivateRoutes,
];
const publicRoutes = [...authRoutes, ...miscPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes };
